export const getTemplateSetting = (state) => state.viewer.templateSettings;

export const getTemporarySetting = (state) => state.viewer.templateSettings.temporarySetting;

export const getTableColumns = (state) => state.viewer.templateSettings.tableColumns;

export const getSettingsItems = (state) => state.viewer.templateSettings.settingsItems;

export const getFilterScheme = (state) => state.viewer.templateSettings.filtersSchemes;

export const getCustomProperties = (state) => state.viewer.customPropertiesValues;
